import { useQueryClient } from '@tanstack/react-query';

import {
    getGetClientEntraSignInsByClientIdQueryKey,
    useDeleteClientEntraSignIn,
} from 'api/v3/client-entra-sign-ins/client-entra-sign-ins';
import { ClientEntraSignInModel } from 'api/v3/models';
import { DeleteItemAction } from 'shared/components/DeleteItemAction';

export const DeleteEntraSignInAction = (entraSignIn: ClientEntraSignInModel) => {
    const { mutateAsync: deleteEntraSignInAsync } = useDeleteClientEntraSignIn();
    const queryClient = useQueryClient();

    const handleDeleteEntraSignIn = async () => {
        await deleteEntraSignInAsync({ clientEntraSignInId: entraSignIn.id });
        await queryClient.invalidateQueries({
            queryKey: getGetClientEntraSignInsByClientIdQueryKey(entraSignIn.clientId),
        });
    };

    return (
        <DeleteItemAction
            itemType="entraSignIn"
            name={entraSignIn.displayName ?? entraSignIn.entraId}
            onDeleteItem={handleDeleteEntraSignIn}
        />
    );
};
